import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  implementationTypeField: '[data-implementation-type-field]',
  implementationPolicyField: '[data-implementation-policy-field]',
  implementationProcedureField: '[data-implementation-procedure-field]',
  implementationProductField: '[data-implementation-product-field]',
  implementationVendorField: '[data-implementation-vendor-field]',
  implementationDescriptionField: '[data-implementation-description-field]',
};

export default class ImplementationsForm extends Component {
  static selector = '[data-comp-implementations-form]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.implementationTypeField = this.$container.querySelector(
      this.$options.implementationTypeField,
    );
    this.implementationPolicyField = this.$container.querySelector(
      this.$options.implementationPolicyField,
    );
    this.implementationProcedureField = this.$container.querySelector(
      this.$options.implementationProcedureField,
    );
    this.implementationProductField = this.$container.querySelector(
      this.$options.implementationProductField,
    );
    this.implementationVendorField = this.$container.querySelector(
      this.$options.implementationVendorField,
    );
    this.implementationDescriptionField = this.$container.querySelector(
      this.$options.implementationDescriptionField,
    );

    this.adminImplementationID =
      this.$container.dataset.compImplementationAdminId;

    this.initListeners();
  }

  initListeners() {
    this.implementationTypeField?.addEventListener('change', () => this.refreshVisibility());
    this.implementationPolicyField?.addEventListener('change', () => this.refreshVisibility());
    this.implementationProcedureField?.addEventListener('change', () => this.refreshVisibility());

    // Trigger once on load
    this.refreshVisibility();
  }

  refreshVisibility() {
    const isAdmin = parseInt(this.implementationTypeField?.value, 10) === 2;
    const policyHasValue = this.implementationPolicyField?.value.trim() !== '';
    const procedureHasValue =
      this.implementationProcedureField?.value.trim() !== '';

    if (isAdmin) {
      // Admin implementation type
      if (policyHasValue) {
        this.show(this.implementationPolicyField, '.base-select-group');
        this.hide(this.implementationProcedureField, '.base-select-group');
      } else if (procedureHasValue) {
        this.show(this.implementationProcedureField, '.base-select-group');
        this.hide(this.implementationPolicyField, '.base-select-group');
      } else {
        // Both empty: show both
        this.show(this.implementationPolicyField, '.base-select-group');
        this.show(this.implementationProcedureField, '.base-select-group');
      }

      this.hide(this.implementationProductField, '.base-form--item');
      this.hide(this.implementationVendorField, '.base-form--item');
    } else {
      // Non-admin implementation
      this.hide(this.implementationPolicyField, '.base-select-group');
      this.hide(this.implementationProcedureField, '.base-select-group');
      this.show(this.implementationProductField, '.base-form--item');
      this.show(this.implementationVendorField, '.base-form--item');
    }
  }


  show(element, parentSelector) {
    if (!element) return;
    const parent = element.closest(parentSelector);
    if (parent) {
      parent.style.display = 'block';
    }

    element.style.display = 'block';
  }

  hide(element, parentSelector) {
    if (!element) return;
    const parent = element.closest(parentSelector);
    if (parent) {
      parent.style.display = 'none';
    }

    element.style.display = 'none';
  }
}
